module.exports = __webpack_public_path__ + "media/images/magnifyingglass-059a9a808101eb324ef005c0b7b616ea.png";